module.exports = __webpack_public_path__ + "static/media/instructor-alex.0c3ec73a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instructor-alex.png
// module id = 357
// module chunks = 0